import Skeleton from '@carvana/ds-skeleton';
import {
  LoadingTileContainer,
  TileTopSectionContent,
  TileTopSectionWrapper
} from './RecentSearches.styles';

export default function LoadingRecentSearchTile() {
  return (
    <LoadingTileContainer data-testid="loading-recent-search-tile">
      <TileTopSectionWrapper>
        <TileTopSectionContent>
          {/* date */}
          <Skeleton height="16px" width="80px" />

          {/* search name */}
          <div className="flex flex-col gap-sm">
            <Skeleton height="20px" width="150px" />
            <Skeleton height="20px" width="100px" />
          </div>
        </TileTopSectionContent>
        <div className="h-32 w-32">
          <Skeleton height="24px" width="24px" className="mx-auto" />
        </div>
      </TileTopSectionWrapper>

      {/* results */}
      <div className="mt-auto flex items-center gap-md">
        <Skeleton height="16px" width="100px" />
      </div>
    </LoadingTileContainer>
  );
}
